import { render, staticRenderFns } from "./rewardDealList.vue?vue&type=template&id=7ca8ad87"
import script from "./rewardDealList.vue?vue&type=script&lang=js"
export * from "./rewardDealList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports